import { createAppStore } from '@store/createAppStore';

import { INITIAL_CUSTOMER_DETAILS } from './defaultVals';
import {
  CreditRequestState,
  CustomerDetailState,
  ediConfigurationStateType,
  ediConfigurationType,
  ICreditRequest,
} from './types';

const [customerDetailsStore, setCustomerDetailsStore] =
  createAppStore<CustomerDetailState>(
    {
      isLoading: false,
      isError: false,
      errorMessage: '',
      customer: INITIAL_CUSTOMER_DETAILS,
      assignOfficeGroup: [],
      customerFlagReviewModalModeAndLoading: {
        mode: 'add',
        loading: false,
      },
      customerFlagReviewData: [],
      customerFlagTypes: [],
      customerFlagPermissions: {
        canFlagForReview: false,
        canFlagFinancialExposure: false,
      },
      selectedCustomerFlagReviewData: null,
      portals: [],
    },
    'customerDetailsStore',
  );

const [ediConfigurationStore, setEdiConfigurationStore] =
  createAppStore<ediConfigurationStateType>(
    {
      isLoading: true,
      isError: false,
      errorMessage: '',
      ediData: {} as ediConfigurationType,
      ediProviders: [] as string[],
      isSaveLoading: false,
    },
    'ediConfigurationStore',
  );

const [creditRequestStore, setCreditRequestStore] =
  createAppStore<CreditRequestState>(
    {
      isLoading: false,
      isError: false,
      errorMessage: '',
      creditRequest: {} as ICreditRequest,
    },
    'creditRequestStore',
  );

export {
  creditRequestStore,
  customerDetailsStore,
  ediConfigurationStore,
  setCreditRequestStore,
  setCustomerDetailsStore,
  setEdiConfigurationStore,
};
